import { render, staticRenderFns } from "./ComingOtherWrapper.vue?vue&type=template&id=eb18f66c&scoped=true"
import script from "./ComingOtherWrapper.vue?vue&type=script&lang=js"
export * from "./ComingOtherWrapper.vue?vue&type=script&lang=js"
import style0 from "./ComingOtherWrapper.vue?vue&type=style&index=0&id=eb18f66c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb18f66c",
  null
  
)

export default component.exports